module.exports = __webpack_public_path__ + "static/media/hat-girl.fcb3bc20.jpg";